import React from 'react';
import { Box, Typography } from '@mui/material';
import { DialogTitleWithClose } from '../../../common';

const DialogHeader = ({ templateName, onClose, disableClose = false }) => {
  return (
    <DialogTitleWithClose
      title={
        <Box>
          <Typography variant="h6">A/B Test Experiments</Typography>
          {templateName && (
            <Typography variant="body2" color="text.secondary">
              {templateName}
            </Typography>
          )}
        </Box>
      }
      onClose={onClose}
      disableClose={disableClose}
    />
  );
};

export default DialogHeader;
